export default {
  'component.tagSelect.expand': 'Expand',
  'component.tagSelect.collapse': 'Collapse',
  'component.tagSelect.all': 'All',
  'component.menuSearch.placeholder': 'Search menu',
  'component.menuSearch.empty': 'No matching pages',
};
